import React, { useEffect, useMemo, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { roundInfoStore, useTranslation } from '@pascal/pascal-core';

import { roundTimeStore } from '../../../store';
import { globalTranslationKeys } from '../../../enums';

const BetsClosedPopUp = observer(() => {
  const t = useTranslation();
  const { time } = roundTimeStore;
  const { duration } = roundInfoStore;
  const [subClass, setSubClass] = useState(null);

  const betsInfoPopUpText = useMemo(() => {
    if (time > duration * 0.3) {
      setSubClass('primary');
      return t(globalTranslationKeys.PLACE_YOUR_BETS);
    }
    if (time <= duration * 0.3 && time >= duration * 0.1) {
      setSubClass('warning');
      return t(globalTranslationKeys.BETS_ARE_CLOSING);
    }
    if (time === 0 || time < duration * 0.1) {
      setSubClass('danger');
      return t(globalTranslationKeys.BETS_ARE_CLOSED);
    }
    return null;
  }, [time, t]);

  useEffect(() => {
    if (!time) {
      setSubClass(null);
    }
  }, []);

  return time || time === 0 ? (
    <div className={`monti-notification ${subClass}`}>
      <p className='monti-notification-txt'>{betsInfoPopUpText}</p>
    </div>
  ) : (
    <></>
  );
});

export default BetsClosedPopUp;
